(() => {
  const template = document.getElementById('kf-pdp-discount-template');
  if (!template || window.kfPdpDiscountInitialized) return;
  window.kfPdpDiscountInitialized = true;
  const root = window.Shopify?.routes?.root || '/';
  let cart, product, pending, queued;
  const widgets = new Map();
  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency', currency:cart?.currency || 'USD'}).format(cents / 100);
  const text = (el, value) => {if (el.textContent !== value) el.textContent = value;};
  function selection(button) {
    if (button.disabled || button.getAttribute('aria-disabled') === 'true') return null;
    if (button.matches('.kf-shopify-add')) {
      const shop = window.KFSickDayShopify;
      const age = document.querySelector('[data-kf-selected-age]')?.getAttribute('data-kf-selected-age');
      const flavor = document.querySelector('[data-kf-selected-flavor]')?.getAttribute('data-kf-selected-flavor');
      if (!shop?.purchasableAges?.[age]) return null;
      return {variantId:shop.variants[age+'|'+flavor], planId:null};
    }
    const form = button.closest('form');
    const variantId = form?.querySelector('[name="id"]')?.value;
    const planId = form?.querySelector('[name="selling_plan"]:not(:disabled)')?.value;
    return variantId ? {variantId,planId} : null;
  }
  function render() {
    if (!product) return;
    for (const [button, badge] of widgets) if (!button.isConnected) {badge.remove();widgets.delete(button);}
    const code = cart?.discount_codes?.find(d => d.code.toUpperCase() === 'KINDER15');
    const enabled = code && (code.applicable || cart.item_count === 0);
    document.querySelectorAll('main [data-add-to-cart], .kit-section .kf-shopify-add').forEach(button => {
      let badge = widgets.get(button);
      const selected = selection(button);
      const variant = product.variants.find(v => String(v.id) === String(selected?.variantId));
      const allocation = selected?.planId ? variant?.selling_plan_allocations?.find(a => String(a.selling_plan_id) === String(selected.planId)) : null;
      const price = selected?.planId ? allocation?.price : variant?.price;
      const visible = Boolean(!window.KFPrimeSale?.get(selected?.variantId) && enabled && variant?.available && Number.isFinite(price));
      if (!badge && !visible) return;
      if (!badge) {
        badge = template.content.firstElementChild.cloneNode(true);
        button.before(badge);widgets.set(button,badge);
      }
      if (badge.hidden === visible) badge.hidden = !visible;
      if (!visible) return;
      // Match Shopify's integer-cent percentage allocation, verified against live carts.
      const saving = Math.floor(price * 15 / 100);
      text(badge.querySelector('[data-kf-discount-before]'), money(price));
      text(badge.querySelector('[data-kf-discount-after]'), money(price-saving));
      text(badge.querySelector('[data-kf-discount-saving]'), money(saving));
      text(badge.querySelector('[data-kf-discount-heading]'), selected.planId ? template.dataset.subscription : template.dataset.applied);
    });
  }
  function queue() {clearTimeout(queued);queued=setTimeout(render,80);}
  async function refresh() {
    if (document.hidden || pending) return pending;
    pending = (async () => {
      try {
        const response = await fetch(root+'cart.js',{credentials:'same-origin',cache:'no-store',signal:AbortSignal.timeout(8000)});
        if (!response.ok) throw new Error('Cart unavailable');
        cart = await response.json();
      } catch {cart=null;}
      finally {pending=null;queue();}
    })();
    return pending;
  }
  document.addEventListener('kf:discount-updated', event => {cart=event.detail;queue();});
  document.addEventListener('change',queue);
  document.addEventListener('input',queue);
  window.addEventListener('popstate',queue);
  window.addEventListener('pageshow',refresh);
  window.addEventListener('focus',refresh);
  document.addEventListener('visibilitychange',refresh);
  // Reconcile changes made by cart drawers or another tab without patching theme requests.
  setInterval(refresh,15000);
  const target = document.querySelector('main') || document.querySelector('.kit-section');
  if (target) new MutationObserver(queue).observe(target,{subtree:true,childList:true,attributes:true,attributeFilter:['value','disabled','aria-disabled','data-kf-selected-age','data-kf-selected-flavor']});
  fetch(template.dataset.productUrl+'.js',{credentials:'same-origin',signal:AbortSignal.timeout(8000)})
    .then(r=>{if(!r.ok) throw new Error('Product unavailable');return r.json();})
    .then(value=>{product=value;queue();}).catch(()=>{});
  refresh();
})();
